export default {
  storefront_not_found: {
    title: 'Aucune vitrine trouvée',
    description: 'Veuillez créer une vitrine.',
  },
};
